import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/chat/empty-img-default.svg'


const _withScopeId = n => (_pushScopeId("data-v-75c985d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "rightContent",
  "element-loading-text": "Loading..."
}
const _hoisted_2 = {
  key: 0,
  class: "firstBox"
}
const _hoisted_3 = ["infinite-scroll-disabled"]
const _hoisted_4 = {
  key: 0,
  style: {"height":"100%"}
}
const _hoisted_5 = ["element-loading-text"]
const _hoisted_6 = {
  key: 0,
  class: "noMore"
}
const _hoisted_7 = {
  key: 2,
  class: "empty"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "empty-text" }
const _hoisted_10 = {
  key: 1,
  class: "secondBox"
}
const _hoisted_11 = { class: "mailContent" }
const _hoisted_12 = {
  key: 2,
  class: "thirdBox"
}
const _hoisted_13 = { class: "phoneContent" }

import { ref, computed, watch, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import chatItem from "@/components/chat/contentItem/chatItem.vue";
import mailItem from "@/components/chat/contentItem/mailItem.vue";
import { getChatContentListApi, getFileLinkApi } from "@/api/chat/index";
import emitter from "@/utils/eventBus";
import {
  chatType,
  sendSide,
  chatContentRes,
} from "@/components/chat/config/chatConfig";
import { getQueryParam, isImageOrVideo, gaEvent } from "@/utils/format";
import { useI18n } from "vue-i18n";
import axios from "axios";
import loading from "@/components/chat/loading.vue";

type chatContentType = {
  type: string;
  content: string;
  date: string;
  send_side: string | number;
  sender: string;
  id?: number;
  avatar?: string;
  chat_type?: string;
  file_name?: string;
  oss_key?: string;
  size?: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'rightContent',
  props: {
  // 被监控的app名称
  appName: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



// const chatGlobalLoading2 = ref(true)

const currentLang = computed(() => store.state.currentLang);

const store = useStore();

// const isDemo = getQueryParam(location.href, 'isDemo')
// store.commit('setIsDemo', parseInt(isDemo))

const isDemoRef = computed(() => store.state.isDemo);

const datePickerValue = computed(() => store.state.datePickerValue);

// 控制loading图标是否出现
const contentLoading = ref(false);

// 获取当前激活向的tab名称
const activeTabName = computed(() => {
  return store.state.activeTabName;
});

const deviceId = computed(() => store.state.currentDeviceInfo.id);
watch([activeTabName, deviceId], async () => {
  // console.log("activeTabName改变了00", activeTabName.value);
  chatContentList.value = [];
  cumulativeList = [];
  chatPageNum.value = 1;
  chatLoading.value = false;
  noMoreChat.value = false;
  chatLoading.value = false;
  // console.log(chatContentList.value, "chatContentList.value");

  if (activeTabName.value === "first") {
    try {
      chatGlobalLoading.value = true;
      const res: any = await getChatContentList(chat_session_key.value, true);
      chatLoading.value = false;
      // if (chatContentList.value.length % chatPageSize.value != 0) {
      if (chatContentList.value.length >= res.total) {
        noMoreChat.value = true;
      }
    } catch (err) {
      console.log(err);
      chatLoading.value = false;
    }
  }
});

// // 获取当前点击项的详细信息
// const mailItemDetail = computed(() => {
//     return store.state.clickMailItemDetail
// })

const phoneItemDetail = computed(() => {
  return store.state.clickPhoneItemDetail;
});

// ===========chatContent============l
const chatLoading = ref(false);
const noMoreChat = ref(false);
const chatPageNum = ref(1); // 页码
let chatPageSize = ref(15); // 一页多少条数据
let chatGlobalLoading = ref(true);
const disabledChatScroll = computed(
  () => chatLoading.value || noMoreChat.value
);
// 获取当前选中的会话的chat_session_key，向后端请求聊天记录内容
const chat_session_key = computed(() => store.state.clickItemKey);

const sessionClickItemUniqueId = computed(
  () => store.state.sessionClickItem?.unique_id
);

const currentDeviceId = computed(() => store.state.currentDeviceInfo.id);

// 左侧会话列表数据加载成功后触发，开始根据chat_session_key请求右侧聊天记录内容列表数据
// emitter.on("startQuest", async (key) => {
//     console.log("rightContent接收到leftTabs发出的事件了", chat_session_key.value, key);
//     try {
//         chatContentList.value = []
//         chatGlobalLoading.value = true
//         await getChatContentList(key);
//         chatGlobalLoading.value = false
//     } catch (err) {
//         console.log(err);
//         chatGlobalLoading.value = false
//     }
// });

// 左侧会话列表数据加载失败后触发
emitter.on("closeChatLoading", () => {
  if (activeTabName.value === "first") {
    // console.log('closeChatLoading');

    chatGlobalLoading.value = false;
  }
});

emitter.on("closeLoading", () => {
  if (activeTabName.value !== "first") {
    // console.log('closeLoading');

    chatGlobalLoading.value = false;
  }
});

// 监听左侧列表项被点击,点击后更新右侧聊天记录内容列表数据
watch([sessionClickItemUniqueId], async (newVal, oldVal) => {
  // console.log('sessionClickItemUniqueId改变了');
  // 重置所有数据
  try {
    cumulativeList = []; // 先重置清空原来的聊天列表数据
    chatContentList.value = [];
    chatPageNum.value = 1;
    chatLoading.value = false;
    noMoreChat.value = false;
    chatLoading.value = false;
    chatGlobalLoading.value = true;
    // 向后端发送请求，获取当前点击项对应的聊天列表内容
    await getChatContentList(chat_session_key.value);
    const chatContentDom = document.querySelector("#chatContent") as any;
    if (chatContentDom) {
      chatContentDom.scrollTop = 0; // 让滚动条恢复到最顶部
    }
  } catch (err) {
    console.log(err);
  }
});

// 监听时间筛选值的变化，时间值发生改变后更新右侧聊天记录内容列表数据
watch([datePickerValue], async (newVal, oldVal) => {
  // console.log('datePickerValue改变了rightContent');
  chatPageNum.value = 1;
  chatContentList.value = [];
  cumulativeList = [];
  chatLoading.value = false;
  noMoreChat.value = false;
  chatLoading.value = false;
  chatGlobalLoading.value = true;
  // console.log(chatContentList.value, 'chatContentList')
  await getChatContentList(chat_session_key.value);
});

let chatContentList = ref<any[]>([]);
// 所有的聊天记录内容
let cumulativeList: any[] = [];

// 根据oos_key获取对应的文件下载地址
const getFileLinkByKey = async (oss_key: any) => {
  const data = {
    oss_key: oss_key,
  };
  try {
    const res = await getFileLinkApi(data);
    // console.log(res, 'getFileLinkByKey');
    if (res.data.code == 200) {
      const fileURL = res.data.data.url;
      return new Promise((resolve, reject) => {
        resolve(fileURL);
      });
    }
  } catch (err) {
    console.log(err);
  }
};
const fileStatus = ref("loading");

// const deviceId = computed(() => store.state.currentDeviceInfo.id)

// 获取聊天列表内容
const getChatContentList = async (key: any, isScroll: boolean = false) => {
  try {
    let onePageList: any = [];
    let start = parseInt(datePickerValue.value[0]);
    let end = parseInt(datePickerValue.value[1]);
    const params: any = {
      // chat_session_id: 'c574d251-eaca-4ffe-ac17-feb5c417c3bb',
      // device_id: '123456789abc',
      device_id: deviceId.value,
      app: props.appName,
      chat_session_id: key,
      start: start,
      // end: 1662260309,
      end: end,
      page: chatPageNum.value,
    };

    let res: any;
    if (isDemoRef.value) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          // console.log('假数据');
          res = chatContentRes;
          if (res.data.code == 200) {
            const key = chat_session_key.value;
            onePageList = res.data.data.messages[key];
            // console.log(555);

            chatGlobalLoading.value = false;
            fileStatus.value = "success";
            cumulativeList = cumulativeList.concat(onePageList);
            chatContentList.value = cumulativeList;
            noMoreChat.value = true;
            resolve(res.data.data);
          }
        }, 500);
      });
    } else {
      const sourceRef = computed(() => store.state.source);
      // 取消掉上一次请求
      sourceRef.value && sourceRef.value.cancel("请勿频繁请求接口");
      res = await getChatContentListApi(params);
      if (res.data.code == 200) {
        // if (res.config.params.chat_session_id == chat_session_key.value && isWatch) {
        //     cumulativeList = [] // 先重置清空原来的聊天列表数据
        //     // console.log(cumulativeList);
        //     chatContentList.value = []
        //     console.log('chatContentList2', chatContentList.value);
        //     console.log('cumulativeList2', cumulativeList);
        // }
        // console.log(res.config.params, 'res1');
        // console.log(res.config.params.chat_session_id, 'res');

        // console.log(params.key, 'params.key');
        // console.log(chat_session_key.value, 'chat_session_key');
        // if (res.config.params.chat_session_key == chat_session_key.value) {
        //     console.log('222');
        // }
        onePageList = res.data.data.messages;
        // 遍历消息列表，对非文本类型的消息进行特殊处理，通过oss_key向阿里云发请求拿到在线url放入file_url字段中
        const onePageListPromise = onePageList.map(
          async (item: any, index: any) => {
            // if (item.type != chatType.text && item.type != sendSide.systemSide) {
            if (item.oss_key) {
              const fileURL = await getFileLinkByKey(item.oss_key);
              let realType = item.type;
              if (item.type == 9) {
                // 如果是网格图类型，则判断实际是图片还是视频类型
                realType = isImageOrVideo(item.file_name) == "video" ? 3 : 2;
              }
              return {
                ...item,
                file_url: fileURL,
                type: realType,
              };
            } else {
              return item;
            }
          }
        );
        onePageList = await Promise.all(onePageListPromise);
        // 解决快速点击左侧会话列表时，右侧内容区数据错乱问题 方案一
        /* if ((res.config.params.chat_session_id == chat_session_key.value) && !isScroll) {
                    cumulativeList = [] // 先重置清空原来的聊天列表数据
                    console.log('[]]');
                    chatContentList.value = []
                    // console.log('chatContentList2', chatContentList.value);
                    // console.log('cumulativeList2', cumulativeList);
                    // chatGlobalLoading.value = false
                    // fileStatus.value = 'success'
                    // // console.log(onePageList, 'onePageList');
                    // cumulativeList = cumulativeList.concat(onePageList);
                    // // console.log("cumulativeList:", cumulativeList);
                    // chatContentList.value = cumulativeList;
                    // console.log('chatContentList222:', chatContentList.value);
                    // return res.data.data
                }
                chatGlobalLoading.value = false
                fileStatus.value = 'success'
                // console.log(onePageList, 'onePageList');
                cumulativeList = cumulativeList.concat(onePageList);
                // console.log("cumulativeList:", cumulativeList);
                chatContentList.value = cumulativeList;
                console.log('chatContentList222:', chatContentList.value);
                return res.data.data
 */
        // 解决快速点击左侧会话列表时，右侧内容区数据错乱问题 方案二,只有当前保存的激活项chat_session_key和请求头中的保持一致时，才进行合并数据操作
        if (res.config.params.chat_session_id == chat_session_key.value) {
          fileStatus.value = "success";
          cumulativeList = cumulativeList.concat(onePageList);
          chatContentList.value = cumulativeList;
          // console.log('6666');

          chatGlobalLoading.value = false;
          return res.data.data;
        } else {
          return {};
        }
      }
    }
  } catch (err: any) {
    // 这里主要是判断这个错误是取消请求导致的还是其他原因导致的
    if (axios.isCancel(err)) {
      console.log(err.message);
    }
    console.log(err);
    if (
      err.message != "请勿频繁请求接口" &&
      err.message != "请勿频繁请求会话列表接口" &&
      err.message != "请勿频繁请求通讯录列表接口"
    ) {
      // console.log(777);

      chatGlobalLoading.value = false;
    }
    fileStatus.value = "error";
  } finally {
    // chatGlobalLoading.value = false
  }
};

// 获取更多聊天记录内容，滚动到底部时触发该函数
const loadMoreChatContentList = () => {
  // console.log('loadMoreChatContentList');
  chatLoading.value = true;
  setTimeout(async () => {
    try {
      chatPageNum.value++;
      const res: any = await getChatContentList(chat_session_key.value, true);
      chatLoading.value = false;
      // if (chatContentList.value.length % chatPageSize.value != 0) {
      if (chatContentList.value.length >= res.total) {
        noMoreChat.value = true;
      }
    } catch (err) {
      console.log(err);
      chatLoading.value = false;
    }
  }, 100);
};

watch(chatGlobalLoading, (newVal, oldVal) => {
  try {
    if (chatGlobalLoading.value && currentLang.value == "ar") {
      nextTick(() => {
        const loadingText = document.querySelector(".el-loading-text") as any;
        loadingText.style.direction = "rtl";
      });
    }
  } catch (err) {
    console.log(err);
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (activeTabName.value === 'first')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(['chatContent', _unref(chatGlobalLoading) ? 'loading-flex' : '']),
            "infinite-scroll-immediate": false,
            "infinite-scroll-disabled": disabledChatScroll.value,
            "infinite-scroll-distance": "2",
            id: "chatContent"
          }, [
            (_unref(chatContentList).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatContentList), (item, index) => {
                    return _renderSlot(_ctx.$slots, "chatContentItem", {
                      key: index,
                      msgObj: {
              layout: item.send_side == _unref(sendSide).ourSide ? 'right' : 'left',
              message: item,
              fileStatus: fileStatus.value,
            }
                    })
                  }), 128)),
                  _withDirectives(_createElementVNode("div", {
                    "element-loading-text": _ctx.$t('chat.loadingText'),
                    style: {}
                  }, null, 8, _hoisted_5), [
                    [_directive_loading, chatLoading.value]
                  ]),
                  (noMoreChat.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_unref(chatGlobalLoading))
                ? (_openBlock(), _createBlock(loading, {
                    key: 1,
                    class: "loading"
                  }))
                : (!_unref(chatGlobalLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                    ]))
                  : _createCommentVNode("", true)
          ], 10, _hoisted_3)), [
            [_directive_infinite_scroll, loadMoreChatContentList]
          ])
        ]))
      : (activeTabName.value === 'second')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(mailItem, {
                label: "mail",
                phoneItemDetail: {}
              })
            ])
          ]))
        : (activeTabName.value === 'third')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _renderSlot(_ctx.$slots, "phoneContentItem", { phoneItemDetail: phoneItemDetail.value })
              ])
            ]))
          : _createCommentVNode("", true)
  ])), [
    [_directive_loading, contentLoading.value]
  ])
}
}

})